import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Truck, Package, Globe, BarChart2, FileText } from 'lucide-react';

const clients = [
  { icon: <Truck size={32} />, titleKey: 'clientType1' },
  { icon: <Package size={32} />, titleKey: 'clientType2' },
  { icon: <Globe size={32} />, titleKey: 'clientType3' },
  { icon: <BarChart2 size={32} />, titleKey: 'clientType4' },
  { icon: <FileText size={32} />, titleKey: 'clientType5' },
];

const WhoWeWorkWith = () => {
  const { t } = useTranslation();

  return (
    <section id="who-we-work-with">
      <style>{`
        .www-section {
          background: linear-gradient(135deg, #0f2350 0%, #1b3f82 50%, #2563eb 100%);
          border-top: 1px solid rgba(71,146,244,0.30);
          padding: 5rem 2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3rem;
        }
        .www-header { text-align: center; }
        .www-title {
          font-size: clamp(1.8rem, 3vw, 2.6rem);
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 0.5rem;
        }
        .www-subtitle {
          font-size: 1rem;
          color: #c0d8ff;
          margin: 0;
        }
        .www-cards {
          max-width: 1100px;
          width: 100%;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 1.25rem;
        }
        .www-card {
          background: rgba(255,255,255,0.88);
          border: 1px solid rgba(255,255,255,0.22);
          border-radius: 16px;
          padding: 2rem 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 1rem;
          transition: transform 0.2s, background 0.2s, border-color 0.2s, box-shadow 0.2s;
          cursor: default;
        }
        .www-card:hover {
          transform: translateY(-4px);
          background: #d4e5ff;
          border-color: rgba(71,146,244,0.4);
          box-shadow: 0 8px 24px rgba(71,146,244,0.12);
        }
        .www-icon {
          width: 4rem;
          height: 4rem;
          border-radius: 50%;
          background: #d4e5ff;
          border: 1px solid rgba(71,146,244,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #4792f4;
        }
        .www-card-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #0f1f40;
          margin: 0;
        }
        @media (max-width: 1000px) {
          .www-cards { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 640px) {
          .www-cards { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 400px) {
          .www-cards { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="www-section">
        <motion.div
          className="www-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="www-title">{t('whoWeWorkWithTitle')}</h2>
        </motion.div>

        <div className="www-cards">
          {clients.map((client, i) => (
            <motion.div
              key={i}
              className="www-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
            >
              <div className="www-icon">{client.icon}</div>
              <p className="www-card-title">{t(client.titleKey)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWith;
